// useAxios.js

import { useContext, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import { showToast } from './toastService';

const useAuthService = () => {
  const {setIsAuthenticated,setUserData } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  const notifySuccess = (message) => {
    showToast(message, "dark");
  };
  const notifyError = (message) => {
    showToast(message, "warn");
  };

  const sendRequest = async (config) => {
    setLoading(true);
    setError(null);

    try {
      const response = await axios(config);
      notifySuccess('Fetching UserData Success')
      setIsAuthenticated(true)
      setUserData(response.data)

      return response.data;
    } catch (error) {
      notifyError('Errer Fetching UserData')
      setError(error);
      setIsAuthenticated(false)
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const get = async (url, params = {}) => {
    const config = { url, method: 'GET', params };
    return await sendRequest(config);
  };

  const post = async (url, data = {}) => {
    const config = { url, method: 'POST', data };
    return await sendRequest(config);
  };

  // Add methods for other HTTP request types as needed (e.g., put, delete, etc.)

  return { loading, error, get, post };
};

export default useAuthService;
